import { Card, CardActions, CardContent, Dialog, Typography } from "@mui/material";
import VButton from "../Common/VButton";

const style = {
  header: {
    mt: 2,
    mb: 3,
    fontWeight: 700,
  },
};

const EndDialog = (props: {
  isOpen: boolean;
  downloadWords: () => void;
  showRecording: boolean;
  downloadRecording: () => void;
  navigateFunction: () => void;
}) => {
  return (
    <Dialog open={props.isOpen}>
      <Card sx={{ boxShadow: 0 }}>
        <CardContent>
          <Typography align="center" variant="h6" sx={style.header}>
            Test sooritatud!
          </Typography>
          {props.showRecording && (
            <CardActions sx={{ justifyContent: "center" }}>
              <VButton text="Laadi alla helisalvestus" onClick={props.downloadRecording} />
            </CardActions>
          )}
          <CardActions sx={{ justifyContent: "center" }}>
            <VButton text="Laadi alla vastuste leht" onClick={props.downloadWords} />
          </CardActions>
          <CardActions sx={{ justifyContent: "center" }}>
            <VButton text="Avalehele" type="outlined" onClick={props.navigateFunction} />
          </CardActions>
        </CardContent>
      </Card>
    </Dialog>
  );
};

export default EndDialog;
